import type { CatalogoResponse, ServicioStatsResponse } from '@aid/shared';
import { KpiRow } from '../../dashboard/components/KpiRow';
import { KpiCard } from '../../dashboard/components/KpiCard';
import { useT } from '../../../locales';

interface ServiciosKpisProps {
  stats: ServicioStatsResponse | undefined;
  statsLoading: boolean;
  caption?: string;
  estadosCatalogo: CatalogoResponse[];
}

function activosIdsDe(estadosCatalogo: CatalogoResponse[]): Set<number> {
  return new Set(
    estadosCatalogo
      .filter((e) => `${e.key ?? ''} ${e.value ?? ''}`.toUpperCase().includes('ACTIVO'))
      .map((e) => Number(e.id)),
  );
}

export function ServiciosKpis({
  stats,
  statsLoading,
  caption,
  estadosCatalogo,
}: ServiciosKpisProps) {
  const t = useT();
  const statsEmpty = statsLoading && !stats;
  const activos =
    stats?.porEstado
      .filter((pe) => pe.idEstado !== null && activosIdsDe(estadosCatalogo).has(pe.idEstado))
      .reduce((acc, pe) => acc + pe.count, 0) ?? 0;

  return (
    <div style={{ marginBottom: 16 }}>
      <KpiRow>
        <KpiCard
          label={t('pages.servicios.kpis.total')}
          value={String(stats?.total ?? 0)}
          formatValue={false}
          caption={caption}
          empty={statsEmpty}
        />
        <KpiCard
          label={t('pages.servicios.kpis.activos')}
          value={String(activos)}
          formatValue={false}
          accent="pagos"
          caption={caption}
          empty={statsEmpty}
        />
        <KpiCard
          label={t('pages.servicios.kpis.clientesUnicos')}
          value={String(stats?.clientesUnicos ?? 0)}
          formatValue={false}
          accent="clientes"
          caption={caption}
          empty={statsEmpty}
        />
        <KpiCard
          label={t('pages.servicios.kpis.planes')}
          value={String(stats?.planesDistintos ?? 0)}
          formatValue={false}
          caption={caption}
          empty={statsEmpty}
        />
      </KpiRow>
    </div>
  );
}
